var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 15,
  fill: "none",
  viewBox: "0 0 14 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3C97AA",
  d: "M14 7.5 0 0l4.5 7.5L0 15l14-7.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B6BBC7",
  d: "M14 7.5 0 0l4.5 7.5L0 15l14-7.5Z"
})));
export { SvgIcSend as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDcuNUwwIDBMNC41IDcuNUwwIDE1TDE0IDcuNVoiIGZpbGw9IiMzQzk3QUEiLz4KPHBhdGggZD0iTTE0IDcuNUwwIDBMNC41IDcuNUwwIDE1TDE0IDcuNVoiIGZpbGw9IiNCNkJCQzciLz4KPC9zdmc+Cg==";